async function handleCartItemStockAvailable() {
  try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        let outOfStockItems = [];
        let updatedCartItems = [];
        const payload = {
            variants_id: cart.items.map(item => String(item.variant_id))
        };
        const url = `${SHOPIFY_APP_BASE_URL}/check-items-variant-stock`;
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        };
        const inventoryResponse = await fetch(url, options);
        const inventoryData = await inventoryResponse.json();
        const variantInventoryData = inventoryData.data;
        cart.items.forEach(item => {
            const variant = variantInventoryData[item.variant_id];
            if (variant) {
                const variantAvailableForSale = variant.availableForSale;
                const variantSellableOnlineQuantity = Math.max(0, variant.sellableOnlineQuantity); // Treat negatives as 0
                const variantInventoryPolicy = variant.inventoryPolicy;

                if(!variantAvailableForSale){
                    if(variantInventoryPolicy === "DENY" && variantSellableOnlineQuantity < item.quantity){
                        //alert(item.image);
                        outOfStockItems.push({ id: item.id, title: item.product_title , image: item.image });
                        console.warn(`Variant ${item.variant_id} is out of stock or insufficient.`);
                    }
                } else {
                    updatedCartItems.push(item);
                    //console.log(`Variant ${item.variant_id} is available.`);
                }
            } else {
                outOfStockItems.push({ id: item.id, title: item.product_title, image: item.image });
                console.warn(`No inventory data found for variant ${item.variant_id}.`);
            }
        });
        if (outOfStockItems.length > 0) {
                hideOhnutsLoadingSpinner();
                let alertMessage = "<div style='padding:5px;'><h3>The following items are out of stock and will be removed:</h3>";
                outOfStockItems.forEach(item => {
                    alertMessage += `<div style="display: flex; align-items: center; gap: 10px;">
                                        <img src="${item.image}" alt="${item.title}" width="50"
                                        height="50" style="border-radius: 17px;border: 1px solid #ddd;">
                                        <span>${item.title}</span>
                                    </div>`;
                });
                alertMessage += `</div>`
                const updatePayload = {
                updates: outOfStockItems.reduce((acc, item) => {
                    acc[item.id] = 0; // Set quantity to 0 to remove
                    return acc;
                }, {})
                };
                const cartupdate = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatePayload)
                });
                const cartData = await cartupdate.json();
                if (cartData) {
                    return { status: false, msg: alertMessage };
                }
        } else {
            //console.log("All items are in stock.");
            return { status: true };
        }
    } catch (error) {
        console.error("Error fetching cart data:", error);
        //alert("Failed to check inventory. Please try again later.");
        return { status: false };
    }
}

